import { Role } from '@/contexts/AuthContext';

export function isTicketRole(roleId: number | undefined) {
  return roleId === Role.Admin || roleId === Role.Root;
}
